import type {
    CreateTaskForListInput,
    TaskOccurrenceStatus,
    TaskListWithTaskOccurrences,
} from "@dashboard/api/task";

export type TaskFormValues = {
    clientId?: string;
    id?: number;
    title: string;
    description?: string | null;
    groupId?: number | null;
    // Fields carried over from a template task that the form doesn't edit
    copy?: CreateTaskForListInput;
};

export type GroupFormValues = {
    id?: number;
    title: string;
    tasks: TaskFormValues[];
};

export type ListFormValues = {
    title: string;
    description: string | null;
    template: boolean;
    responsibleUserId: number | null;
    tasks: TaskFormValues[];
    groups: GroupFormValues[];
};

export type ListRow = TaskListWithTaskOccurrences & {
    completedTasks: number;
    totalTasks: number;
    isCompleted: boolean;
    progressPercent: number;
};

export const isAnswered = (occurrences: { status: TaskOccurrenceStatus }[]) => {
    const status = occurrences[0]?.status;
    return status === "DONE" || status === "BLOCKED";
};

export function getListTaskCounts(list: TaskListWithTaskOccurrences): {
    completedTasks: number;
    totalTasks: number;
} {
    const ungroupedCompleted = list.tasks?.filter((t) => isAnswered(t.occurrences)).length || 0;
    const groupedCompleted =
        list.groups?.reduce(
            (acc, group) =>
                acc + (group.tasks?.filter((t) => isAnswered(t.occurrences)).length || 0),
            0,
        ) || 0;

    const ungroupedTotal = list.tasks?.length || 0;
    const groupedTotal =
        list.groups?.reduce((acc, group) => acc + (group.tasks?.length || 0), 0) || 0;

    return {
        completedTasks: ungroupedCompleted + groupedCompleted,
        totalTasks: ungroupedTotal + groupedTotal,
    };
}
